import { LazyAutocompleteFieldNotMultiple } from '@occc-app/design-system';

import {
  mapRetailerNetworkCustomerQueryResponseToRawArray,
  makeRetailerNetworkCustomerFilter,
} from './retailer-network-configuration.utils';
import { RetailerNetworkCustomerAutocompleteItem } from './retailer-network-configuration.types';

import { useGetRetailerNetworkCustomerLazy } from '../../data-access/queries';

export const mapRawRetailerNetworkCustomerResponseItemToAutocompleteOption = (
  item: RetailerNetworkCustomerAutocompleteItem,
) => ({
  value: item.uuid,
  label: item.name,
  _raw: item,
});

type RetailerNetworkCustomerAutocompleteProps = {
  dataTestId?: string;
  isRequired?: boolean;
  disabled?: boolean;
};

export const RetailerNetworkCustomerAutocomplete = ({
  dataTestId,
  isRequired,
  disabled,
}: RetailerNetworkCustomerAutocompleteProps) => (
  <LazyAutocompleteFieldNotMultiple<
    RetailerNetworkCustomerAutocompleteItem,
    ReturnType<typeof useGetRetailerNetworkCustomerLazy>['response']
  >
    name='customerId'
    label='Customer Name'
    disabled={!!disabled}
    data-testid={dataTestId}
    useLazyQuery={useGetRetailerNetworkCustomerLazy}
    makeQueryFilter={makeRetailerNetworkCustomerFilter}
    mapQueryResponseToRawArray={mapRetailerNetworkCustomerQueryResponseToRawArray}
    mapRawResponseItemToAutocompleteOption={
      mapRawRetailerNetworkCustomerResponseItemToAutocompleteOption
    }
    inputProps={{ margin: 'none', required: !!isRequired }}
    first={30}
  />
);
